// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
import { SECTOR_VALUES } from './regulatory.js';
import { DATA_EXPLOITATION_ROUTES, PERSONAL_DATA_PROCESSING_SERVICES, REGULATED_ENTITY_TYPES, } from './org-profile-vocabularies.js';
export const ORG_PROFILE_ATTRIBUTES = {
    sector: {
        source: { collection: 'grc_org_settings', field: 'sectors' },
        vocabulary: SECTOR_VALUES,
        statement: 'list',
    },
    data_exploitation_routes: {
        source: { collection: 'grc_org_profile_statements', field: 'values' },
        vocabulary: DATA_EXPLOITATION_ROUTES,
        statement: 'recorded',
    },
    regulated_entity_types: {
        source: { collection: 'grc_org_profile_statements', field: 'values' },
        vocabulary: REGULATED_ENTITY_TYPES,
        statement: 'recorded',
    },
    personal_data_processing_services: {
        source: { collection: 'grc_org_profile_statements', field: 'values' },
        vocabulary: PERSONAL_DATA_PROCESSING_SERVICES,
        statement: 'recorded',
    },
};
/** The registry's attribute names, as a value — derived, never restated. */
export const ORG_PROFILE_ATTRIBUTE_NAMES = Object.keys(ORG_PROFILE_ATTRIBUTES);
export function isOrgProfileAttribute(value) {
    return (typeof value === 'string' && Object.prototype.hasOwnProperty.call(ORG_PROFILE_ATTRIBUTES, value));
}
/**
 * The attributes stated as an append-only recorded statement — Sprint 62.53.0.
 *
 * Written out as a tuple (a type a reader of the tree can enumerate, which a
 * mapped type over the registry is not — the row-access census reported the
 * mapped form UNDECIDED), and held to the registry in BOTH directions by the two
 * compile-time checks below: a listed name must be a `recorded` attribute, and
 * every `recorded` attribute must be listed.
 */
export const ORG_PROFILE_RECORDED_ATTRIBUTE_NAMES = [
    'data_exploitation_routes',
    'regulated_entity_types',
    'personal_data_processing_services',
];
/** Every listed name is recorded in the registry… */
const _recordedListedAreRecorded = ORG_PROFILE_RECORDED_ATTRIBUTE_NAMES;
/** …and every recorded attribute of the registry is listed. */
const _recordedRegistryIsListed = null;
void _recordedListedAreRecorded;
void _recordedRegistryIsListed;
/** Whether a value names a recorded attribute (`sector` is a list, and is not one). */
export function isRecordedOrgProfileAttribute(value) {
    return isOrgProfileAttribute(value) && ORG_PROFILE_ATTRIBUTES[value].statement === 'recorded';
}
/** A profile in which nothing is stated — the answer for an unknown organisation. */
export function emptyOrgProfile() {
    const out = {};
    for (const name of ORG_PROFILE_ATTRIBUTE_NAMES)
        out[name] = { state: 'not_stated' };
    return out;
}
//# sourceMappingURL=org-profile.js.map